var render = function render(){var _vm=this,_c=_vm._self._c;return _c('th',{style:(_vm.thStyleObj)},[_c('div',{staticClass:"th-box"},[_c('span',{staticClass:"th-text"},[_vm._v(_vm._s(_vm.thText))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }